import PropTypes from 'prop-types';
import React from 'react';

import './CharCount.scss';

export default class CharCount extends React.PureComponent {
    constructor(props) {
        super();
    }

    static propTypes = {
        length: PropTypes.number.isRequired,
        limit: PropTypes.number.isRequired,
    };

    static defaultProps = {
        length: 0,
        limit: 0,
    };

    render() {
        const length = this.props.length;
        const currentLabel = length.toLocaleString();
        const limit = this.props.limit;
        const limitLabel = limit.toLocaleString();

        return limit ? (
            <span
                className={`component-Elements-CharCount ${
                    length >= limit ? 'count-error' : ''
                }`}
            >
                {currentLabel}&#65295;{limitLabel}
            </span>
        ) : null;
    }
}
